import Router from "./route/Index";

import ThemeProvider from "./layout/provider/Theme";
import { listenNotifications } from "./notificationListener";
import { useEffect } from "react";

const App = () => {

  useEffect(() => {
    const initNotifications = async () => {
      await listenNotifications();
    };
    initNotifications();
  }, []);
  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
};
export default App;